export default "__VITE_ASSET__BcxbTYUi__"